<div class="login-container" *ngIf="authStatusChceked">
  <div class="login-center-area">
    <!-- Vericure Logo -->
    <div class="logo-container">
      <img src="assets/VericureLogo1.png" alt="Vericure Logo" class="vericure-logo">
    </div>
    
    <h2>Sign In</h2>
    <div class="login-options">
      <form (ngSubmit)="onEmailLogin()" #loginForm="ngForm">
        <div class="form-group">
          <div class="input-box" [class.error]="emailError">
            <span class="icon id-pwd-icon">
              <i class="fa-solid fa-envelope"></i>
            </span>
            <input type="email" placeholder="Email" [(ngModel)]="email" name="email" #emailInput="ngModel" />
            <label>Email</label>
          </div>
          <span class="error-message" [class.visible]="emailError">{{ emailError ? 'Email is required' : '&nbsp;' }}</span>
          
          <div class="input-box" [class.error]="passwordError">
            <span class="icon id-pwd-icon">
              <i class="fa-solid fa-key"></i>
            </span>
            <input type="password" placeholder="Password" [(ngModel)]="password" name="password" #passwordInput="ngModel" />
            <label>Password</label>
          </div>
          <span class="error-message" [class.visible]="passwordError">{{ passwordError ? 'Password is required' : '&nbsp;' }}</span>
        </div>

        <div class="login-buttons">
          <button type="submit" class="login-button" [disabled]="isLoading">
            <span class="icon btn-icon">
              <i class="fa-solid fa-lock" *ngIf="!isLoading"></i>
              <i class="fa-solid fa-spinner fa-spin" *ngIf="isLoading"></i>
            </span>
            {{ isLoading ? 'Signing In...' : 'Sign In' }}
          </button>
          <button type="button" class="microsoft-login" (click)="onMicrosoftLogin()">
            <span class="icon btn-icon">
              <i class="fa-brands fa-windows"></i>
            </span>
            Sign In with Microsoft
          </button>
          <button type="button" class="google-login" (click)="onGoogleLogin()" [disabled]="isGoogleLoading">
            <span class="icon btn-icon">
              <i class="fa-brands fa-google" *ngIf="!isGoogleLoading"></i>
              <i class="fa-solid fa-spinner fa-spin" *ngIf="isGoogleLoading"></i>
            </span>
            {{ isGoogleLoading ? 'Signing In...' : 'Sign In with Google' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="authprogress-center-area" *ngIf="!authStatusChceked">
  <h4>Authenticating...</h4>
</div>
